



















import { IEmailBlueprint } from '@/store/types';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'PrecisionRetriesBox',
  computed: {
    ...mapGetters([
      'currentCampaignBlueprintSaveState',
      'precisionRetriesEnabled',
    ]),
    allEmails(): IEmailBlueprint[] {
      if (!this.$store.getters.currentCampaignEmailBlueprints) {
        return [];
      }
      return this.$store.getters.currentCampaignEmailBlueprints.filter((email: IEmailBlueprint) => !email.delete);
    },
    hasDisabledEmails(): boolean {
      return this.allEmails.some((email: IEmailBlueprint) => !email.enabled);
    },
    enabledEmails(): IEmailBlueprint[] {
      return this.allEmails.filter((email: IEmailBlueprint) => email.enabled);
    },
    emailsDescription(): string {
      return (this.hasDisabledEmails) ? 'no enabled emails' : 'no emails';
    },
    display(): boolean {
      const noEmails = this.enabledEmails.length === 0;
      const precisionRetriesEnabled = this.precisionRetriesEnabled;
      return noEmails && precisionRetriesEnabled;
    },
  },
});
